import { ICampaignModel } from "./Campaign";

export enum EnumMerchantStatus {
    Pending = 1,
    Accepted = 2,
    Rejected = 3,
    Finished = 4,
    InProgress = 5,
    Canceled = 6,
    PendingApproval = 7,
    Declined = 9
}

export interface IEquipmentListModel {
    IdProject: number;
    EquipmentList: string[];
}

export interface IMerchantModel {
    Id: string;
    IsMain?: boolean;
    Data: IMerchantDataModel,
    IdEntity?: string,
    IsImported?: boolean;
    IsSynchronized?: boolean;
    EconomicActivityCodes: string;
    MerchantFileList?: IMerchantFileModel[];
    ManagerList?: IMerchantManager[];
    LatestStatus?: IMerchantStatus;
    SynchronizedDate?: any,
    LatestVersion?: IMerchantLatestVersion,
    ModuleList?: { Id: any, Name?: string, Status?: { Id?: string } }[],
    CampaignList?: { Id: any, Name?: string, Status?: { Id?: string } }[],
    IdMerchantManager?: string,
    Sources?: IMerchantSourceModel[],
    ProjectEquipmentList?: IEquipmentListModel[],
}
export interface IMerchantManager {
    Id: string;
    IdMerchant: string;
    IdUser: string;
    IsMain?: boolean;
    StartDate?: string;
    EndDate?: string;
    UserPersonalData?: any;
}

export interface IMerchantStatus {
    Id: string;
    IdMerchant: string;
    IdStatus: number;
    Observations: boolean;
    RegistUser?: any;
    Status:
    {
        Id: number;
        IsCompleted: boolean;
        IsSuccess: boolean;
        Name: string;
    };

}
export interface IMerchantFileModel {
    Id?: string;
    IdMerchant?: string;
    IdFile?: string;
    IdAttachmentType?: number;
    IdFileType?: number;
    IsMain: boolean;
    OriginalName?: string;
    File: IFileModel
    FileData?: Blob
}

export class Attachment implements IMerchantFileModel {
    Id?: string;
    IdMerchant?: string;
    IdFile?: string;
    IdAttachmentType?: number;
    IdFileType?: number;
    IsMain: boolean;
    OriginalName?: string;
    File: any;
    FileData?: Blob;

    constructor(data: Partial<Omit<IMerchantFileModel, 'File'>> & { File?: any } = {}) {
        this.Id = data?.Id || null;
        this.IdMerchant = data?.IdMerchant || null;
        this.IdFile = data?.IdFile || null;
        this.IdAttachmentType = data?.IdAttachmentType ?? null;
        this.IdFileType = data?.IdFileType ?? null;
        this.IsMain = data?.IsMain ?? false;
        this.File = data?.File || null;
        this.OriginalName = data?.OriginalName || this.File?.OriginalName || null;
        this.FileData = data?.FileData || null;
    }
}
interface IMerchantLocation {
    Id: number,
    Name?: string,
    ZipCode: string,
    Locality: string,
    Address: string,
    District: string,
    County: string,
    Coordinates: {
        Latitude: string,
        Longitude: string
    }
}

interface IMerchantContact {
    Phone?: string,
    MobilePhone?: string,
    Email?: string,
    LabelPhoneList?: string,
    Id: number,
    RegistDate?: string,
    RegistUser?: number
}

interface IFileModel {
    Id?: string;
    OriginalName: string;
    ByteData?: string;
    Path?: string;
}

interface IMerchantDataModel {
    Id?: string,
    IdLocation?: string,
    IdContact?: string,
    Name: string,
    Description?: string,
    VatNumber: string,
    BankAccountNumber: string,
    Observations?: string,
    FiscalName: string,
    Location: IMerchantLocation,
    Contact: IMerchantContact,
    OwnerBirthPlace?: string,
    ManagerInfo?: IMerchantOwnerInfoModel,
    SubName?: string,
}

interface IMerchantOwnerInfoModel {
    IdUser?: string,
    Name: string,
    VatNumber: string,
    IdentificationDocumentNumber: string,
    IdentificationDocumentValidityDate: string,
    IdentificationDocumentEmissionDate: string,
    BirthDate: string,
    DocumentType: string,
    Contact: IMerchantContact,
    BirthPlace?: string,
    Nationality?: any,
    IdNationality?: any
}

interface IMerchantLatestVersion {
    Id?: string,
    Number: number,
    SubmittedData: string,
    ValidatedData: string,
    IdStatus: number,
    IsCurrent: boolean,
    Status?: any
}


export interface IMerchantsResumeList {

    Id: string;
    RegistDate: string;
    Name: string;
    FiscalName: string;
    OwnerName: string;
    VatNumber: string;
    Observations: string;
    Status: IStatusModel;
    IsSynchronized: boolean;
    SynchronizedDate?: string;
    IdMerchantVersion?: string;
    Categories?: string;
    EconomicActivityList: any[];
    HasMarketplace?: boolean;
}
export class MerchantsResumeList {

    Id: string;
    RegistDate: string;
    Name: string;
    FiscalName: string;
    OwnerName: string;
    VatNumber: string;
    Observations: string;
    Status: IStatusModel;
    IsSynchronized: boolean;
    SynchronizedDate?: string;
    IdMerchantVersion?: string;
    Categories?: string;
    HasMarketplace?: boolean;

    constructor(data: Partial<IMerchantsResumeList> = {}) {

        this.Id = data?.Id || '';
        this.RegistDate = data?.RegistDate || '';
        this.Name = data?.Name || '';
        this.FiscalName = data?.FiscalName || '';
        this.OwnerName = data?.OwnerName || '';
        this.VatNumber = data?.VatNumber || '';
        this.Observations = data?.Observations || '';
        this.Status = new StatusModel(data?.Status);
        this.IsSynchronized = data?.IsSynchronized ?? false;
        this.SynchronizedDate = data?.SynchronizedDate || '';
        this.IdMerchantVersion = data?.IdMerchantVersion || '';

        this.Categories = data?.EconomicActivityList?.map(it => it.Code).join('; ');
        this.HasMarketplace = data?.HasMarketplace ?? false;



    }

}
export interface IStatusModel {
    Id: number;
    Name: string;
    Color?: string;
    Icon?: string;
};

export class StatusModel {
    Id: number;
    Name: string;
    Color?: string;
    Icon?: string;

    constructor(data: Partial<IStatusModel> = {}) {

        this.Id = data?.Id || null;
        this.Name = data?.Name || null;

        // Pending = 1,
        // Accepted = 2,
        // Rejected = 3,
        // Finished = 4,
        // InProgress = 5


        switch (String(this?.Id)) {
            case String(EnumMerchantStatus.Accepted):
            case String(EnumMerchantStatus.Finished):
                this.Color = 'success';
                this.Icon = 'checkmark-outline';
                break;
            case String(EnumMerchantStatus.InProgress):
                this.Color = 'secondary';
                this.Icon = 'hourglass-outline';
                break;
            case String(EnumMerchantStatus.Canceled):
                this.Color = 'danger';
                this.Icon = 'ban-outline';
                break;
            case String(EnumMerchantStatus.Rejected):
                this.Color = 'danger';
                this.Icon = 'close-circle-outline';
                break;
            case String(EnumMerchantStatus.PendingApproval):
                this.Color = 'secondary';
                this.Icon = 'cloud-offline-outline';
                break;
            case String(EnumMerchantStatus.Declined):
                this.Color = 'danger';
                this.Icon = 'pause-circle-outline';
                break;
            default:
                this.Color = 'warning';
                this.Icon = 'warning-outline';
                break;
        }


    }
}

export interface IMerchantSearchDataModel {
    Id?: string;
    Merchant: IMerchantSearchMerchantModel;
    Consumer: IMerchantSearchConsumerModel;
    CampaignList: IMerchantSearchCampaignInfoListModel[];
    DiscountValue?: any,
    ModuleList: {
        CampaignList: {
            Campaign: { Id: string, Name: string },
            Type: { Id: string, Name: string },
            UserCardStartDate?: string,
            UserCardEndDate?: string,
            IsUserAssociated?: boolean,
        }[],
        IsUserAssociated?: boolean,
        Module: { Id: string, Name: string }
    }[]
}

interface IMerchantSearchMerchantModel {
    FiscalName: string;
    VatNumber: string;
    Id: string;
    Name: string;
}

interface IMerchantSearchConsumerModel {
    IdWallet: string;
    VatNumber: string;
    CardNumber: string;
    AvailableBalance: number;
    Id: string;
    Name: string;
}

interface IMerchantSearchCampaignInfoListModel {
    StartDate?: string;
    EndDate?: string;
    AvailableWalletBalance: number;
    Configuration: any;
    MCC: string;
    CaeList?: string[];
    CategoryInfo?: {
        Id: string;
        Name: string;
    },
    Id: string;
    Name: string;
}

export interface IMerchantMovement {
    Id: string;
    Amount: number;
    InvoiceValue: number;
    IsGenericExpense: boolean;
    OccurrenceDate: string;
    Description: string;
    Observations: string;
    DocumentReference: string;
    DocumentInformation: string;
    IsSynchronized: boolean;
    SynchronizedDate: string;
    IdEntity: string;
    IdWallet: string;
    IdCampaignCharging: string;
    Card: {
        Id: string;
        Number: string;
        ValidationDate: string;
        Status: boolean;
    };
    User: {
        BirthDate: string;
        VatNumber: string;
        IdentificationDocumentNumber: string;
        Contact: any;
        Id: string;
        Name: string;
    };
    Type: {
        Id: string;
        Name: string;
    };
    Status: IStatusModel;
    Campaign: {
        Id: string;
        Name: string;
    };
    MerchantCategoryCode: {
        Id: string;
        Code: string;
        Description: string;
        Level: number;
    };
    Merchant: any;
}


export class MerchantMovement implements IMerchantMovement {
    Id: string;
    Amount: number;
    InvoiceValue: number;
    IsGenericExpense: boolean;
    OccurrenceDate: string;
    Description: string;
    Observations: string;
    DocumentReference: string;
    DocumentInformation: string;
    IsSynchronized: boolean;
    SynchronizedDate: string;
    IdEntity: string;
    IdWallet: string;
    IdCampaignCharging: string;
    Card: {
        Id: string;
        Number: string;
        ValidationDate: string;
        Status: boolean;
    };
    User: {
        BirthDate: string;
        VatNumber: string;
        IdentificationDocumentNumber: string;
        Contact: any;
        Id: string;
        Name: string;
    };
    Type: {
        Id: string;
        Name: string;
    };
    Status: IStatusModel;
    Campaign: {
        Id: string;
        Name: string;
    };
    MerchantCategoryCode: {
        Id: string;
        Code: string;
        Description: string;
        Level: number;
    };
    Merchant: any;

    constructor(data: Partial<IMerchantMovement> = {}) {

        this.Id = data?.Id || null;
        this.Amount = data?.Amount || null;
        this.InvoiceValue = data?.InvoiceValue || null;
        this.IsGenericExpense = data?.IsGenericExpense || null;
        this.OccurrenceDate = data?.OccurrenceDate || null;
        this.Description = data?.Description || null;
        this.Observations = data?.Observations || null;
        this.DocumentReference = data?.DocumentReference || null;
        this.DocumentInformation = data?.DocumentInformation || null;
        this.IsSynchronized = data?.IsSynchronized || null;
        this.SynchronizedDate = data?.SynchronizedDate || null;
        this.IdEntity = data?.IdEntity || null;
        this.IdWallet = data?.IdWallet || null;
        this.IdCampaignCharging = data?.IdCampaignCharging || null;
        this.Card = data?.Card || null;
        this.User = data?.User || null;
        this.Type = data?.Type || null;
        this.Status = new StatusModel(data?.Status); null;
        this.Campaign = data?.Campaign || null;
        this.MerchantCategoryCode = data?.MerchantCategoryCode || null;
        this.Merchant = data?.Merchant || null;

    }

}

export interface IMerchantMovementDetails {
    Id: string;
    IdEntity: string;
    IdUser: string;
    IdWallet: string;
    InvoiceData: {
        DiscountValue: number,
        InvoiceValue: number,
        DocumentReference: string,
        DocumentInformation: string,
        AtcudIdentifier?: string
    };
    IsGenericExpense: boolean;
    OccurrenceDate: string;
    Description: string;
    Observations: string;
    Module: {
        Id: string;
        Name: string;
    };
    Currency: {
        Acronym: string;
        Symbol: string;
        IsMain: boolean,
        IsCoin: boolean,
        ExchangeRate: number,
        Label: string;
        Id: number,
        Name: string;
    };
    Type: {
        Id: string,
        Name: string
    };
    User: IMerchantMovementDetailsUser;
    Card: {
        Id: string;
        Number: string;
        Status: boolean
    };
    Merchant: {
        SubName: string;
        FiscalName: string;
        VatNumber: string;
        Id: string;
        Name: string;
    };
    Campaign: {
        Id: string,
        Name: string,
    };
    MovementFileList: any[];
    Status: IStatusModel
    SynchronizedDate: string;
    ObservationsOCR?: string;
    ObservationsPSW?: string;
    AttachedVoucher?: any;
}

export class MerchantMovementDetails implements IMerchantMovementDetails {

    Id: string;
    IdEntity: string;
    IdUser: string;
    IdWallet: string;
    InvoiceData: {
        DiscountValue: number,
        InvoiceValue: number,
        DocumentReference: string,
        DocumentInformation: string,
        AtcudIdentifier?: string
    };
    IsGenericExpense: boolean;
    OccurrenceDate: string;
    Description: string;
    Observations: string;
    Module: {
        Id: string;
        Name: string;
    };
    Currency: {
        Acronym: string;
        Symbol: string;
        IsMain: boolean,
        IsCoin: boolean,
        ExchangeRate: number,
        Label: string;
        Id: number,
        Name: string;
    };
    Type: {
        Id: string,
        Name: string
    };
    User: IMerchantMovementDetailsUser;
    Card: {
        Id: string;
        Number: string;
        Status: boolean
    };
    Merchant: {
        SubName: string;
        FiscalName: string;
        VatNumber: string;
        Id: string;
        Name: string;
    };
    Campaign: {
        Id: string,
        Name: string,
    };
    MovementFileList: any[];
    Status: IStatusModel
    SynchronizedDate: string;
    AttachedVoucher?: any;
    ObservationsOCR?: string;

    constructor(data: Partial<IMerchantMovementDetails> = {}) {

        this.Id = data?.Id || null;
        this.IdWallet = data?.IdWallet || null;
        this.IdWallet = data?.IdWallet || null;
        this.InvoiceData = data?.InvoiceData || null;
        this.IsGenericExpense = data?.IsGenericExpense || null;
        this.OccurrenceDate = data?.OccurrenceDate || null;
        this.Description = data?.Description || null;
        this.Observations = data?.Observations || null;
        this.Module = data?.Module || null;
        this.Currency = data?.Currency || null;
        this.Type = data?.Type || null;
        this.User = new MerchantMovementDetailsUser(data?.User);
        this.Card = data?.Card || null;
        this.Merchant = data?.Merchant || null;
        this.Campaign = data?.Campaign || null;
        this.MovementFileList = data?.MovementFileList || [];
        this.Status = new StatusModel(data?.Status);
        this.SynchronizedDate = data?.SynchronizedDate || null;
        this.AttachedVoucher = data?.AttachedVoucher || null;
        this.ObservationsOCR = data?.ObservationsOCR || null;
        this.Observations = data?.Observations || null;

    }

}



export interface IMerchantMovementDetailsUser {

    Id: string;
    Name: string;
    VatNumber: string;
    Contact: {
        Phone: string,
        MobilePhone: string,
        Email: string
    };

    VatNumberHidden?: string;
}



export class MerchantMovementDetailsUser implements IMerchantMovementDetailsUser {
    Id: string;
    Name: string;
    VatNumber: string;
    Contact: {
        Phone: string,
        MobilePhone: string,
        Email: string
    };


    constructor(data: Partial<IMerchantMovementDetailsUser> = {}) {

        this.Id = data?.Id || null;
        this.Name = data?.Name || null;
        this.VatNumber = data?.VatNumber || null;
        this.Contact = data?.Contact || null;
    }

    get VatNumberHidden(): string {

        return this.VatNumber ? `xxxxx${(this.VatNumber).substring(this.VatNumber.length - 4)}` : '';

    }
}

// ─── Merchant Sources / Links ────────────────────────────────────────────────

export enum EnumSourceType {
    Marketplace = 1,
    Website = 2,
    Facebook = 3,
    Instagram = 4,
    Twitter = 5,
    LinkedIn = 6,
    YouTube = 7,
    TikTok = 8,
    WhatsApp = 9,
    Other = 10
}

export interface IMerchantSourceModel {
    Type: EnumSourceType;
    Url: string;
    Icon?: string;
    IdProject?: string;
}

export class MerchantSourceUtils {

    private static readonly map: Record<EnumSourceType, { icon: string; label: string }> = {
        [EnumSourceType.Marketplace]: { icon: 'storefront-outline', label: 'Marketplace' },
        [EnumSourceType.Website]: { icon: 'globe-outline', label: 'Website' },
        [EnumSourceType.Facebook]: { icon: 'logo-facebook', label: 'Facebook' },
        [EnumSourceType.Instagram]: { icon: 'logo-instagram', label: 'Instagram' },
        [EnumSourceType.Twitter]: { icon: 'logo-twitter', label: 'Twitter' },
        [EnumSourceType.LinkedIn]: { icon: 'logo-linkedin', label: 'LinkedIn' },
        [EnumSourceType.YouTube]: { icon: 'logo-youtube', label: 'YouTube' },
        [EnumSourceType.TikTok]: { icon: 'logo-tiktok', label: 'TikTok' },
        [EnumSourceType.WhatsApp]: { icon: 'logo-whatsapp', label: 'WhatsApp' },
        [EnumSourceType.Other]: { icon: 'link-outline', label: 'Other' },
    };

    public static get Keys(): EnumSourceType[] {
        return Object.values(EnumSourceType).filter(v => typeof v === 'number') as EnumSourceType[];
    }

    public static GetIcon(type: EnumSourceType): string {
        return this.map[type]?.icon ?? 'link-outline';
    }

    public static GetLabel(type: EnumSourceType): string {
        return this.map[type]?.label ?? 'Link';
    }

    public static Open(url: string): void {
        if (!url) return;
        window.open(url, '_blank');
    }
}